module.exports = __webpack_public_path__ + "static/img/step-101.3b914a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-101.png
// module id = 8bdq
// module chunks = 1